export default __webpack_public_path__ + "static/media/title-black.72bd084d.png";